import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { IconButton } from "@circle-react-uikit/HeaderV3/IconButton";
import type { QuestionPayload } from "./index";

interface OptionItemProps {
  checkCorrectAnswersError: (
    payload: Omit<QuestionPayload, "cover_media">,
  ) => boolean;
  hasCorrectAnswersError: boolean;
  onRemove: (index: number, payload: { id: number; _destroy: boolean }) => void;
  onSelect?: () => void;
  optionIndex: number;
  questionType: "single_choice" | "multiple_choice";
}
export const OptionItem = ({
  optionIndex,
  onRemove,
  questionType,
  onSelect,
  hasCorrectAnswersError,
  checkCorrectAnswersError,
}: OptionItemProps) => {
  const { watch, getValues, setError, clearErrors } = useFormContext();
  const option = watch(`options[${optionIndex}]`);
  const correct = watch(`options[${optionIndex}].correct`);

  useEffect(() => {
    if (hasCorrectAnswersError) {
      setError(`options[${optionIndex}].value`, {
        type: "select_correct_answer",
      });
    } else {
      clearErrors(`options[${optionIndex}].value`);
    }
  }, [hasCorrectAnswersError, optionIndex, setError, clearErrors]);

  useEffect(() => {
    const options = getValues("options");
    checkCorrectAnswersError({ options, question_type: questionType });
  }, [checkCorrectAnswersError, correct, getValues, questionType]);

  if (option._destroy) return null;

  return (
    <div className="flex items-center">
      <Form.Item
        name={`options[${optionIndex}].correct`}
        hideLabel
        hideDescription
        hideBorder
        className="!mr-1 !p-0"
      >
        <Form.Checkbox
          isRoundedFull={questionType === "single_choice"}
          name={`options[${optionIndex}].correct`}
          className="!mt-0"
          {...(questionType === "single_choice" && { onChange: onSelect })}
        />
      </Form.Item>
      <Form.Item
        required
        name={`options[${optionIndex}].value`}
        hideLabel
        hideDescription
        hideBorder
        hideError
        className="!grow !p-0"
      >
        <Form.Input
          name={`options[${optionIndex}].value`}
          autoComplete="off"
          maxLength={255}
        />
      </Form.Item>
      <IconButton
        type="button"
        ariaLabel={t("remove")}
        name="20-close"
        variant="primary"
        onClick={() => onRemove(optionIndex, { id: option.id, _destroy: true })}
        iconSize={20}
        className="!ml-3 !p-0"
      />
    </div>
  );
};
